import React from 'react'
import {
    Checkbox,
    Grid,
    Header,
    Icon,
    Image,
    Menu,
    Segment,
    Sidebar,
} from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'

const SidebarExampleSidebar = () => {
    const [visible, setVisible] = React.useState(false)

    return (
        <>
        <Checkbox
            checked={visible}
            label={{ children: <code>visible</code> }}
            onChange={(e, data) => setVisible(data.checked)}
        />
        <Sidebar.Pushable as={Segment}>
            <Sidebar
                as={Menu}
                animation='overlay'
                icon='labeled'
                inverted
                onHide={() => setVisible(false)}
                vertical
                visible={visible}
                width='thin'
            >
                <Menu.Item as='a'>
                    <Icon name='home' />
        Home
      </Menu.Item>
                <Menu.Item as='a'>
                    <Icon name='gamepad' />
        Games
      </Menu.Item>
                <Menu.Item as='a'>
                    <Icon name='camera' />
        Channels
      </Menu.Item>
            </Sidebar>

            <Sidebar.Pusher>
                <Segment basic>
                    <Header as='h3'>Application Content</Header>
                    <Image src='https://react.semantic-ui.com/images/wireframe/paragraph.png' />
                </Segment>
            </Sidebar.Pusher>
        </Sidebar.Pushable>
        </>
  )
}

export default SidebarExampleSidebar
